import { render, staticRenderFns } from "./EditContractRiskLevel.vue?vue&type=template&id=b30bdba0&"
import script from "./EditContractRiskLevel.vue?vue&type=script&lang=js&"
export * from "./EditContractRiskLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports